module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ja":{"aria.loading":"読み込み中"},"en":{"aria.loading":"Loading"}}')
  delete Component.options._Ctor
}
